import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import {
  getDeepReservationsByProductType,
  getReservationsByProductType,
  reservationContainsProductType,
} from 'utils/helpers';

// Return all experiences with ferry
const getExperienceWithFerry = (currentBooking) => {
  const experienceWithFerry = [];
  // Get all experience reservations from booking object
  const experienceReservations = getReservationsByProductType(
    'experience',
    currentBooking
  );

  // Check if experience reservation contains ferry
  if (experienceReservations?.length) {
    experienceReservations.forEach((reservation) => {
      if (reservationContainsProductType('ferry', reservation)) {
        experienceWithFerry.push(reservation);
      }
    });
  }

  return experienceWithFerry;
};

// Return reservation of accommodation
const getAccommodationReservation = (currentBooking) => {
  const accommodationReservations = getDeepReservationsByProductType(
    'accommodation',
    currentBooking
  );
  return accommodationReservations;
};

const getConflictReservationWithExperience = (currentBooking, product) => {
  const unscheduledFerryInBooking = getReservationsByProductType(
    'unscheduledFerry',
    currentBooking
  );
  const ferryInBooking = getReservationsByProductType(
    'ferry,transfer',
    currentBooking
  );
  const accomInBooking = getReservationsByProductType(
    'accommodation',
    currentBooking
  );
  const reservationTypes = [];
  const ferryReservationIds = [];
  const reservations = [];

  if (!isEmpty(ferryInBooking) && product.hasFerry) {
    reservationTypes.push('ferry trip');
    reservations.push(...ferryInBooking);
    // Mark the ferry reservation ids
    ferryReservationIds.push(...reservations.map((res) => res.id));
  }

  if (!isEmpty(unscheduledFerryInBooking) && product.hasFerry) {
    reservationTypes.push('unscheduledFerry');
    reservations.push(...unscheduledFerryInBooking);
  }

  if (!isEmpty(accomInBooking) && product.hasAccommodation) {
    reservationTypes.push('accommodation');
    reservations.push(...accomInBooking);
  }

  const reservationsExcludeFerry = reservations.filter(
    (reservation) => !ferryReservationIds.includes(reservation.id)
  );

  return { reservations, reservationsExcludeFerry, reservationTypes };
};

export function useReservationRemoval(scene, currentBooking, product) {
  const [reservationTobeDeleted, setReservationTobeDeleted] = useState([]);
  const [reservationsExcludeFerry, setReservationsExcludeFerry] = useState([]);
  const [reservationTypes, setReservationTypes] = useState([]);

  useEffect(() => {
    if (!isEmpty(currentBooking)) {
      if (scene === 'ferry') {
        setReservationTobeDeleted(getExperienceWithFerry(currentBooking));
      } else if (scene === 'accommodation') {
        setReservationTobeDeleted(getAccommodationReservation(currentBooking));
      } else if (scene === 'experience') {
        const {
          reservations: reservationTobeDeletedT,
          reservationsExcludeFerry: reservationsExcludeFerryT,
          reservationTypes: reservationTypesT,
        } = getConflictReservationWithExperience(currentBooking, product);

        setReservationTobeDeleted(reservationTobeDeletedT);
        setReservationsExcludeFerry(reservationsExcludeFerryT);
        setReservationTypes(reservationTypesT);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scene, currentBooking]);

  return { reservationTobeDeleted, reservationsExcludeFerry, reservationTypes };
}
